var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.99991 1.49976C13.1362 1.49976 16.4999 4.86426 16.4999 8.99976C16.4999 13.1353 13.1362 16.4998 8.99991 16.4998C4.86441 16.4998 1.49991 13.1353 1.49991 8.99976C1.49991 4.86426 4.86441 1.49976 8.99991 1.49976Z",
    fill: "#2666FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91811 5.83432C8.06136 5.83432 8.20536 5.88907 8.31486 5.99857L10.9301 8.60107C11.0359 8.70682 11.0951 8.85007 11.0951 9.00007C11.0951 9.14932 11.0359 9.29257 10.9301 9.39832L8.31486 12.0023C8.09511 12.2213 7.73961 12.2213 7.51986 12.0008C7.30086 11.7803 7.30161 11.4241 7.52136 11.2051L9.73611 9.00007L7.52136 6.79507C7.30161 6.57607 7.30086 6.22057 7.51986 6.00007C7.62936 5.88907 7.77411 5.83432 7.91811 5.83432Z",
    fill: "#2666FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.86910cd917e6396b0912b8e4e584bcd5.svg";
export { ForwardRef as ReactComponent };